module.exports = __webpack_public_path__ + "static/img/home_banner_4.d8ed7c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_banner_4.png
// module id = I6PJ
// module chunks = 0